import axiosInstance from './axiosInstance'; 

export const fetchTrainings = async () => {
  const response = await axiosInstance.get('/training/');
  return response.data;
};